import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Skill, SkillCategory } from '../../portfolio.data';
import { IconComponent } from '../ui/icon.component';
import { RevealDirective } from '../../directives/reveal.directive';

@Component({
  selector: 'app-skills',
  standalone: true,
  imports: [CommonModule, IconComponent, RevealDirective],
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss']
})
export class SkillsComponent {
  @Input({ required: true }) skills!: Skill[];

  readonly categoryOrder: SkillCategory[] = [
    'Front-end',
    'Back-end',
    'Mobile',
    'Bases de données',
    'Outils / DevOps'
  ];

  get groupedSkills(): { category: SkillCategory; items: Skill[] }[] {
    return this.categoryOrder.map((category) => ({
      category,
      items: this.skills.filter((skill) => skill.category === category)
    }));
  }
}
